exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".search-bar {\n  margin-top: 20px; }\n  .search-bar .search-clear {\n    background-color: #ffffff; }\n    .search-bar .search-clear:hover {\n      background-color: #eeeeee;\n      cursor: pointer; }\n\n.no-results {\n  margin-top: 100px;\n  text-align: center; }\n\n.spinner {\n  text-align: center; }\n  .spinner .spinner-obj {\n    height: 100px !important;\n    width: 100px !important;\n    margin-top: 30px;\n    display: inline-block; }\n\n@media (max-width: 767px) {\n  .search-bar .input-group-addon {\n    border-top-left-radius: 0; }\n  .search-bar .form-control {\n    border-top-right-radius: 0; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./modules/browse/css/browse.scss
// module id = 528
// module chunks = 0